import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { TicketService } from '../../../../services/ticket.service';
import { AdminTicketService } from '../../../../services/adminticket.service';
import { GeneralService } from '../../../../services/general.service';

@Component({
  selector: 'app-admin-support-ticket-view',
  templateUrl: './admin-support-ticket-view.component.html',
  styleUrls: ['./admin-support-ticket-view.component.css']
})
export class AdminSupportTicketViewComponent implements OnInit {

  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  id: number;
  data: any;
  lang: any;
  ticket: any
  conversations: any;
  categories: any;
  userDetails: any;
  details:any;
  timezone = localStorage.getItem('timezone');
  userProfile: any;

  replyForm: FormGroup;
  replyFormSubmitted: Boolean = false;
  replyFormErrorMsg: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ticketService: TicketService,
    private adminticketService: AdminTicketService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    let userType = localStorage.getItem('super_user');
    this.userProfile = this.sanitizer.bypassSecurityTrustUrl(localStorage.getItem('userProfile'));

    this.route.params.subscribe( params => {
      this.id = params.id;

      this.ticketService.viewTicket(this.id,userType).subscribe(
        (res) => {
          
          if(res.status) {

            this.data = res.data;
            this.categories = this.data.categories;
            this.ticket = this.data.ticket.details;
            this.conversations = this.data.ticket.conversation;
            this.details = this.data.ticket.details;
            this.userDetails = this.data.ticket.user_details;
            this.lang = this.ticketService.viewLang(this.data);

          }
          // else
            // this.router.navigate(['/super/'+AppFrontRoutes.ADMIN_TICKET_LIST]);
          
        }
      );


    });

    this.FormBuild();

  }

  FormBuild(): void {

    this.replyForm = this.formBuilder.group({
      ticket_id: [this.id],
      content: ['', [Validators.required]],
    });

    this.replyFormErrorMsg = {
      'content': [{ type: 'required', message: 'This field is Required' }],
    }

  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  replyFormSubmit(): void {

    // console.log('test');

    this.replyFormSubmitted = true;

    if (this.replyForm.invalid)
      return;

    this.adminticketService.replyTicket(this.replyForm.value)
      .subscribe(
        (res) => {

          if (res.status) {
            this.generalService.notify_msg('success', res.msg);
            
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.ADMIN_TICKET_VIEW+'/'+this.id]);
            });
          }
          else
            this.generalService.notify_msg('error', res.msg);

      });

  }

}
